import { Container } from "reactstrap"
import { AddSessionEvent } from "./AddSessionEvent"
import { useGetSessionEventsQuery } from "../../features/CallApi"
import { useEffect, useState } from "react";
import { SessionEventList } from "./SessionEventList";
import LoadScreen from "../UI/LoadScreen";


export const SessionEvent = ({ role }) => {

    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [stringFilter, setStringFilter] = useState("");
    const { data, isLoading, isError, refetch } = useGetSessionEventsQuery({ pageIndex, pageSize, stringFilter });

    useEffect(() => {
        refetch()
    }, [])

    return (
        <div>
            <Container>
                <h3>Списки</h3>

                <AddSessionEvent refetchList={refetch} />
                <div className="d-flex">
                    <input type={`text`} id="stringFilter" onChange={
                        (e) => setTimeout(() => { setStringFilter(e.target.value) }, 2000)}
                        placeholder="Поиск.." name="stringFilter" className="form-control" />
                </div>
                {!isLoading ?

                    <SessionEventList pageIndex={pageIndex} data={data.getEvents} setPageIndex={setPageIndex} role={role} totalPages={data.totalPages} />
                    :
                    <LoadScreen />
                }
            </Container>
        </div>
    )

}